// extracted by mini-css-extract-plugin
module.exports = {"element":"c6e8ba5398--element--3aDLg"};